import { MdGridView, MdMergeType, MdCallSplit, MdRotateRight, MdEdit, MdCompress, MdLayers } from 'react-icons/md';

/** Tool navigation items for the PDF Studio sidebar. */
export const STUDIO_TOOLS = [
  {
    id: 'organize',
    label: 'Organize Pages',
    Icon: MdGridView,
    active: true,
    comingSoon: false,
  },
  {
    id: 'convert-to-pdf',
    label: 'Convert to PDF',
    Icon: MdLayers,
    active: true,
    comingSoon: false,
  },
  {
    id: 'merge',
    label: 'Merge PDFs',
    Icon: MdMergeType,
    active: true,
    comingSoon: false,
  },
  {
    id: 'split',
    label: 'Split PDF',
    Icon: MdCallSplit,
    active: true,
    comingSoon: false,
  },
  {
    id: 'rotate',
    label: 'Rotate PDF',
    Icon: MdRotateRight,
    active: true,
    comingSoon: false,
  },
  {
    id: 'edit',
    label: 'Edit PDF',
    Icon: MdEdit,
    active: false,
    comingSoon: true,
  },
  {
    id: 'compress',
    label: 'Compress PDF',
    Icon: MdCompress,
    active: false,
    comingSoon: true,
  },
];
